/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const NAVIGATION_HEIGHT = 48;
export const NAVIGATION_WIDTH = 308;
export const CARD_WIDTH = 272;
export const DISTANCE_FROM_TOP = 60 + 32; // toolbar height + input height
export const DISTANCE_FROM_BOTTOM = 69;
